/* 三國逗陣打 · 元素特效、動態光源與環境氛圍（畫面層，只畫不改遊戲狀態）
 * - 元素命中：依元素噴不同粒子（火星、冰晶、電弧、落葉、毒泡、暗煙、光點、碎石）
 * - 元素反應：每種反應有自己的爆發效果；導電畫出跳躍的電流
 * - 印記：身上的元素印記會持續冒粒子，血條旁有元素字
 * - 光源：火、雷、投射物、燃燒的人會照亮周圍
 * - 環境：雲影、螢火蟲、落葉、江霧、涉水漣漪 */
// @ts-nocheck — 第 2 步只把檔案改成模組，型別在第 4 步補
import { SG } from '../core/sg.ts';

const TAU = Math.PI * 2;
const rnd = (a, b) => a + Math.random() * (b - a);
const EL = SG.EL || {};
const K = SG.K || 0.7;

// ---------- 新的特效種類 ----------
Object.assign(SG.FX, {
  ring(ctx, e, k) { // 擴散的地面圈
    const R = (e.r0 || 20) + (e.r || 120) * (1 - Math.pow(1 - k, 2.4));
    ctx.globalCompositeOperation = 'lighter';
    ctx.globalAlpha = (1 - k) * 0.9; ctx.strokeStyle = e.col; ctx.lineWidth = (e.w || 4) * (1 - k) + 0.5;
    ctx.beginPath(); ctx.ellipse(0, 0, R, R * K * 0.62, 0, 0, TAU); ctx.stroke();
    ctx.globalAlpha = (1 - k) * 0.18; ctx.fillStyle = e.col; ctx.fill();
  },
  burstel(ctx, e, k) { // 反應爆閃：放射光芒＋中心光球
    const R = (e.r || 70) * (0.4 + 0.6 * Math.min(1, k * 4)), a = 1 - k;
    ctx.globalCompositeOperation = 'lighter';
    const g = ctx.createRadialGradient(0, -40, 0, 0, -40, R);
    g.addColorStop(0, 'rgba(255,255,255,' + (0.9 * a).toFixed(3) + ')'); g.addColorStop(0.35, e.col); g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.globalAlpha = a; ctx.fillStyle = g; ctx.beginPath(); ctx.arc(0, -40, R, 0, TAU); ctx.fill();
    ctx.strokeStyle = e.col2 || '#ffffff'; ctx.lineCap = 'round';
    for (let i = 0; i < 12; i++) {
      const ang = i / 12 * TAU + (e.rot || 0), r0 = R * 0.3, r1 = R * (0.9 + (i % 3) * 0.25);
      ctx.lineWidth = 3 * a; ctx.beginPath(); ctx.moveTo(Math.cos(ang) * r0, -40 + Math.sin(ang) * r0 * 0.8); ctx.lineTo(Math.cos(ang) * r1, -40 + Math.sin(ang) * r1 * 0.8); ctx.stroke();
    }
  },
  frost(ctx, e, k) { // 地面結霜：六角冰花
    const a = k < 0.1 ? k / 0.1 : k > 0.6 ? (1 - k) / 0.4 : 1, R = e.r || 60;
    ctx.globalAlpha = a * 0.5; ctx.fillStyle = 'rgba(200,236,255,.5)';
    ctx.beginPath(); ctx.ellipse(0, 0, R, R * K * 0.62, 0, 0, TAU); ctx.fill();
    ctx.globalAlpha = a; ctx.strokeStyle = '#eaf8ff'; ctx.lineWidth = 1.4;
    for (let i = 0; i < 6; i++) {
      const ang = i / 6 * TAU + 0.3, x = Math.cos(ang) * R * 0.9, y = Math.sin(ang) * R * 0.9 * K * 0.62;
      ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(x, y);
      ctx.moveTo(x * 0.55, y * 0.55); ctx.lineTo(x * 0.55 + Math.cos(ang + 0.8) * 10, y * 0.55 + Math.sin(ang + 0.8) * 6);
      ctx.moveTo(x * 0.55, y * 0.55); ctx.lineTo(x * 0.55 + Math.cos(ang - 0.8) * 10, y * 0.55 + Math.sin(ang - 0.8) * 6);
      ctx.stroke();
    }
  },
  zapline(ctx, e, k) { // 電流：從原點跳到每個 pts（相對座標），每幀重新抖動
    if (k > 0.7) return;
    ctx.globalCompositeOperation = 'lighter'; ctx.lineJoin = 'round';
    let px = 0, py = -45;
    for (const [tx, ty0] of e.pts) {
      const ty = ty0 - 45, n = 7, seg = [[px, py]];
      for (let i = 1; i < n; i++) seg.push([px + (tx - px) * i / n + rnd(-14, 14), py + (ty - py) * i / n + rnd(-14, 14)]);
      seg.push([tx, ty]);
      const path = () => { ctx.beginPath(); seg.forEach((p, i) => (i ? ctx.lineTo(p[0], p[1]) : ctx.moveTo(p[0], p[1]))); };
      ctx.globalAlpha = 0.4 * (1 - k); ctx.strokeStyle = e.col; ctx.lineWidth = 9; path(); ctx.stroke();
      ctx.globalAlpha = 1 - k; ctx.strokeStyle = '#ffffff'; ctx.lineWidth = 2.4; path(); ctx.stroke();
      px = tx; py = ty;
    }
  },
  sigil(ctx, e, k, T) { // 施法陣：元素符文圈，大招更大、多一圈
    const a = k < 0.15 ? k / 0.15 : k > 0.7 ? (1 - k) / 0.3 : 1, R = (e.r || 60) * (0.7 + 0.3 * Math.min(1, k * 5));
    ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = a;
    const sq = K * 0.62;
    ctx.save(); ctx.scale(1, sq);
    const g = ctx.createRadialGradient(0, 0, 0, 0, 0, R); g.addColorStop(0, 'rgba(255,255,255,0)'); g.addColorStop(0.75, e.col + '33'); g.addColorStop(1, e.col + '00');
    ctx.fillStyle = g; ctx.beginPath(); ctx.arc(0, 0, R, 0, TAU); ctx.fill();
    ctx.strokeStyle = e.col; ctx.lineWidth = 2.4 / sq * 0.5;
    ctx.beginPath(); ctx.arc(0, 0, R, 0, TAU); ctx.stroke();
    ctx.lineWidth = 1.2; ctx.beginPath(); ctx.arc(0, 0, R * 0.78, 0, TAU); ctx.stroke();
    const rot = T * (e.ult ? 1.6 : 2.4) + (e.seed || 0);
    // 星形
    ctx.beginPath();
    const n = e.ult ? 6 : 5;
    for (let i = 0; i <= n; i++) { const ang = rot + i * (TAU / n) * 2; const x = Math.cos(ang) * R * 0.78, y = Math.sin(ang) * R * 0.78; i ? ctx.lineTo(x, y) : ctx.moveTo(x, y); }
    ctx.stroke();
    if (e.ult) { ctx.beginPath(); ctx.arc(0, 0, R * 1.18, 0, TAU); ctx.setLineDash([10, 8]); ctx.lineDashOffset = -T * 40; ctx.stroke(); ctx.setLineDash([]); }
    ctx.restore();
    // 符文字（不壓扁，才讀得到）
    if (e.ch) {
      ctx.fillStyle = e.col; ctx.font = `900 ${e.ult ? 15 : 12}px "Noto Serif TC", serif`; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
      const m = e.ult ? 8 : 6;
      for (let i = 0; i < m; i++) { const ang = -rot * 0.6 + i / m * TAU; ctx.fillText(e.ch, Math.cos(ang) * R * 0.9, Math.sin(ang) * R * 0.9 * sq); }
    }
  },
  pillar(ctx, e, k) { // 光柱
    const a = k < 0.15 ? k / 0.15 : (1 - k), w = (e.w || 34) * (1 - k * 0.5);
    ctx.globalCompositeOperation = 'lighter';
    const g = ctx.createLinearGradient(0, -320, 0, 0); g.addColorStop(0, 'rgba(255,255,255,0)'); g.addColorStop(0.6, e.col); g.addColorStop(1, '#ffffff');
    ctx.globalAlpha = a * 0.75; ctx.fillStyle = g; ctx.fillRect(-w / 2, -320, w, 320);
    ctx.globalAlpha = a; ctx.strokeStyle = e.col; ctx.lineWidth = 3; ctx.beginPath(); ctx.ellipse(0, 0, w * 1.4, w * 0.5, 0, 0, TAU); ctx.stroke();
  },
});

// ---------- 新的粒子 ----------
const drawParts0 = SG.drawParts;
SG.drawParts = function (ctx, stage) {
  drawParts0(ctx, stage);
  for (const p of stage.parts) {
    if (p.t < 0) continue;
    const k = p.t / p.life, a = 1 - k;
    switch (p.kind) {
      case 'shard':
        ctx.save(); ctx.translate(p.x, p.y); ctx.rotate((p.rot || 0) + p.t * (p.spin || 9)); ctx.globalAlpha = Math.min(1, a * 1.6);
        ctx.fillStyle = '#d8f2ff'; ctx.strokeStyle = '#6fb8e8'; ctx.lineWidth = 1;
        ctx.beginPath(); ctx.moveTo(0, -p.size * 1.8); ctx.lineTo(p.size * 0.7, 0); ctx.lineTo(0, p.size * 1.8); ctx.lineTo(-p.size * 0.7, 0); ctx.closePath(); ctx.fill(); ctx.stroke();
        ctx.restore(); break;
      case 'zap': {
        if (Math.random() < 0.25) break; // 閃爍
        ctx.save(); ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = a; ctx.strokeStyle = p.col || '#fff07a'; ctx.lineWidth = 1.6;
        const L = p.size * 3; let x = p.x, y = p.y; ctx.beginPath(); ctx.moveTo(x, y);
        for (let i = 0; i < 3; i++) { x += rnd(-L, L) * 0.6; y += rnd(-L, L) * 0.6; ctx.lineTo(x, y); }
        ctx.stroke(); ctx.restore(); break;
      }
      case 'leaf': {
        ctx.save(); ctx.translate(p.x + Math.sin(p.t * 6 + (p.ph || 0)) * 10, p.y); ctx.rotate(p.t * 5 + (p.ph || 0)); ctx.globalAlpha = Math.min(1, a * 1.5);
        ctx.fillStyle = p.col || '#8fd19e'; ctx.beginPath(); ctx.ellipse(0, 0, p.size, p.size * 0.45, 0, 0, TAU); ctx.fill();
        ctx.strokeStyle = 'rgba(20,40,20,.5)'; ctx.lineWidth = 0.8; ctx.beginPath(); ctx.moveTo(-p.size, 0); ctx.lineTo(p.size, 0); ctx.stroke();
        ctx.restore(); break;
      }
      case 'bubble':
        ctx.save(); ctx.globalAlpha = a; ctx.strokeStyle = p.col || '#b6f07a'; ctx.fillStyle = 'rgba(150,230,90,.22)'; ctx.lineWidth = 1.3;
        ctx.beginPath(); ctx.arc(p.x + Math.sin(p.t * 8 + p.size) * 3, p.y, p.size * (0.6 + k * 0.6), 0, TAU); ctx.fill(); ctx.stroke(); ctx.restore(); break;
      case 'wisp': {
        ctx.save(); ctx.globalAlpha = a * 0.7;
        const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, p.size * (1 + k));
        g.addColorStop(0, p.col || 'rgba(120,60,200,.9)'); g.addColorStop(1, 'rgba(20,0,40,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(p.x, p.y, p.size * (1 + k) * 0.7, p.size * (1 + k) * 1.3, 0, 0, TAU); ctx.fill(); ctx.restore(); break;
      }
      case 'mote':
        ctx.save(); ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = a * (0.6 + 0.4 * Math.sin(p.t * 20));
        ctx.fillStyle = p.col || '#fff4c8'; ctx.beginPath(); ctx.arc(p.x, p.y, p.size, 0, TAU); ctx.fill();
        ctx.globalAlpha *= 0.35; ctx.beginPath(); ctx.arc(p.x, p.y, p.size * 3, 0, TAU); ctx.fill(); ctx.restore(); break;
      case 'steam': case 'smoke': {
        ctx.save(); const R = p.size * (1 + k * 2.2);
        const g = ctx.createRadialGradient(p.x, p.y, 0, p.x, p.y, R);
        g.addColorStop(0, p.kind === 'steam' ? 'rgba(240,246,250,.55)' : 'rgba(40,36,34,.45)'); g.addColorStop(1, 'rgba(0,0,0,0)');
        ctx.globalAlpha = a; ctx.fillStyle = g; ctx.beginPath(); ctx.arc(p.x, p.y, R, 0, TAU); ctx.fill(); ctx.restore(); break;
      }
      case 'mist': { // 江霧：扁平、很淡，淡入淡出
        ctx.save(); const R = p.size; ctx.globalAlpha = Math.sin(Math.PI * k) * 0.5;
        ctx.translate(p.x, p.y); ctx.scale(1, 0.28);
        const g = ctx.createRadialGradient(0, 0, 0, 0, 0, R); g.addColorStop(0, 'rgba(230,240,246,.35)'); g.addColorStop(1, 'rgba(230,240,246,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(0, 0, R, 0, TAU); ctx.fill(); ctx.restore(); break;
      }
      case 'snow':
        ctx.save(); ctx.globalAlpha = a; ctx.fillStyle = '#f4fbff'; ctx.beginPath(); ctx.arc(p.x + Math.sin(p.t * 3 + p.size * 7) * 4, p.y, p.size, 0, TAU); ctx.fill(); ctx.restore(); break;
      case 'firefly': {
        const fl = 0.5 + 0.5 * Math.sin(p.t * 3 + (p.ph || 0));
        const x = p.x + Math.sin(p.t * 0.9 + (p.ph || 0)) * 26, y = p.y + Math.cos(p.t * 1.3 + (p.ph || 0)) * 14;
        ctx.save(); ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = Math.min(1, k * 4, a * 4) * fl;
        const g = ctx.createRadialGradient(x, y, 0, x, y, 9); g.addColorStop(0, 'rgba(230,255,150,.95)'); g.addColorStop(1, 'rgba(180,255,90,0)');
        ctx.fillStyle = g; ctx.beginPath(); ctx.arc(x, y, 9, 0, TAU); ctx.fill(); ctx.restore(); break;
      }
      case 'ripple':
        ctx.save(); ctx.globalAlpha = a * 0.6; ctx.strokeStyle = '#d8f0ff'; ctx.lineWidth = 1.4;
        ctx.beginPath(); ctx.ellipse(p.x, p.y, p.size * (1 + k * 2.5), p.size * (1 + k * 2.5) * 0.35, 0, 0, TAU); ctx.stroke(); ctx.restore(); break;
    }
  }
};

// ---------- 元素命中的粒子 ----------
const P = (stage, o) => stage.parts.push(Object.assign({ t: 0, g: 0, vx: 0, vy: 0 }, o));
function elBurst(stage, el, x, y, n) {
  n = n || 1;
  const c = EL[el] ? EL[el].col : '#fff';
  switch (el) {
    case 'fire':
      for (let i = 0; i < 9 * n; i++) P(stage, { kind: 'ember', x: x + rnd(-20, 20), y: y - rnd(10, 60), vx: rnd(-60, 60), vy: -rnd(60, 160), life: rnd(0.4, 0.9), size: rnd(1.5, 3.5), col: Math.random() < 0.5 ? '#ffd46b' : '#ff7a3a' });
      for (let i = 0; i < 2 * n; i++) P(stage, { kind: 'smoke', x: x + rnd(-14, 14), y: y - rnd(30, 60), vy: -rnd(20, 40), life: rnd(0.8, 1.3), size: rnd(10, 16) });
      break;
    case 'ice':
      for (let i = 0; i < 7 * n; i++) P(stage, { kind: 'shard', x: x + rnd(-10, 10), y: y - rnd(20, 60), vx: rnd(-140, 140), vy: -rnd(60, 200), g: 520, floor: y + rnd(-6, 6), life: rnd(0.6, 1.1), size: rnd(2, 4), rot: rnd(0, 6) });
      for (let i = 0; i < 5 * n; i++) P(stage, { kind: 'snow', x: x + rnd(-40, 40), y: y - rnd(40, 110), vy: rnd(15, 35), life: rnd(0.9, 1.6), size: rnd(1, 2.2) });
      stage.fx.push({ type: 'frost', ground: true, x, y, f: 1, s: 1, t: 0, life: 1.4, r: 40 + 20 * n, col: c });
      break;
    case 'thunder':
      for (let i = 0; i < 6 * n; i++) P(stage, { kind: 'zap', x: x + rnd(-26, 26), y: y - rnd(10, 80), life: rnd(0.15, 0.4), size: rnd(4, 8), col: Math.random() < 0.5 ? '#fff07a' : '#c8b8ff' });
      stage.fx.push({ type: 'ring', ground: true, x, y, f: 1, s: 1, t: 0, life: 0.35, r: 60, w: 3, col: c });
      break;
    case 'wind':
      for (let i = 0; i < 7 * n; i++) { const ang = rnd(0, TAU); P(stage, { kind: 'leaf', x: x + Math.cos(ang) * 20, y: y - rnd(20, 70), vx: Math.cos(ang) * rnd(80, 180), vy: -rnd(20, 80), g: 60, life: rnd(0.7, 1.2), size: rnd(3, 5), ph: rnd(0, 6), col: Math.random() < 0.3 ? '#d8e8a0' : '#8fd19e' }); }
      stage.fx.push({ type: 'whirl', ground: true, x, y, f: 1, s: 1, t: 0, life: 0.7, col: c });
      break;
    case 'poison':
      for (let i = 0; i < 7 * n; i++) P(stage, { kind: 'bubble', x: x + rnd(-24, 24), y: y - rnd(0, 40), vy: -rnd(20, 60), life: rnd(0.6, 1.2), size: rnd(2.5, 5) });
      for (let i = 0; i < 2 * n; i++) P(stage, { kind: 'wisp', x: x + rnd(-20, 20), y: y - rnd(10, 40), vy: -rnd(10, 30), life: rnd(0.8, 1.2), size: rnd(12, 18), col: 'rgba(130,210,80,.6)' });
      break;
    case 'shadow':
      for (let i = 0; i < 7 * n; i++) P(stage, { kind: 'wisp', x: x + rnd(-24, 24), y: y - rnd(10, 70), vx: rnd(-20, 20), vy: -rnd(30, 70), life: rnd(0.6, 1.1), size: rnd(6, 12) });
      break;
    case 'holy':
      for (let i = 0; i < 10 * n; i++) P(stage, { kind: 'mote', x: x + rnd(-30, 30), y: y - rnd(0, 60), vy: -rnd(40, 90), life: rnd(0.6, 1.2), size: rnd(1.5, 2.8), col: '#fff4c8' });
      break;
    case 'earth':
      for (let i = 0; i < 6 * n; i++) P(stage, { kind: 'rock', x: x + rnd(-14, 14), y: y - 4, vx: rnd(-120, 120), vy: -rnd(120, 240), g: 700, life: rnd(0.7, 1.1), size: rnd(1.5, 3), floor: y + rnd(-8, 8), rot: rnd(0, 6) });
      for (let i = 0; i < 5 * n; i++) P(stage, { kind: 'dust', x: x + rnd(-24, 24), y: y + rnd(-4, 4), vx: rnd(-50, 50), vy: -rnd(5, 25), g: 10, life: rnd(0.6, 1), size: rnd(6, 10) });
      break;
  }
}
SG.elBurst = elBurst;

// 反應效果
const REACT_FX = {
  melt(st, o) { burst(st, o, '#ffb070', 80); elBurst(st, 'fire', o.x, o.y); for (let i = 0; i < 10; i++) P(st, { kind: 'steam', x: o.x + rnd(-30, 30), y: o.y - rnd(20, 70), vy: -rnd(20, 50), life: rnd(0.8, 1.3), size: rnd(12, 20) }); },
  shatter(st, o) { burst(st, o, '#cfefff', 90); for (let i = 0; i < 22; i++) P(st, { kind: 'shard', x: o.x, y: o.y - 50, vx: rnd(-260, 260), vy: -rnd(80, 300), g: 620, floor: o.y + rnd(-10, 10), life: rnd(0.7, 1.2), size: rnd(2.5, 5), rot: rnd(0, 6), spin: rnd(6, 14) }); st.shake = Math.max(st.shake, 7); },
  conduct(st, o) { st.fx.push({ type: 'zapline', x: o.x, y: o.y, f: 1, s: 1, t: 0, life: 0.5, col: '#fff07a', pts: (o.pts || []).map((p) => [p[0] - o.x, p[1] - o.y]) }); (o.pts || []).forEach((p) => elBurst(st, 'thunder', p[0], p[1])); burst(st, o, '#fff07a', 60); },
  firestorm(st, o) { burst(st, o, '#ff7a3a', 90); ring(st, o, '#ff9a4a', 110); },
  burst(st, o) { burst(st, o, '#c8f05a', 110, '#ffb24a'); ring(st, o, '#9be05a', 140); elBurst(st, 'poison', o.x, o.y, 2); elBurst(st, 'fire', o.x, o.y); st.shake = Math.max(st.shake, 6); },
  spread(st, o) { ring(st, o, '#b8ffe0', 180); elBurst(st, 'wind', o.x, o.y, 2); },
  purge(st, o) { st.fx.push({ type: 'pillar', x: o.x, y: o.y, f: 1, s: 1, t: 0, life: 0.8, col: '#ffe9a8' }); elBurst(st, 'holy', o.x, o.y, 2); },
  drain(st, o) { burst(st, o, '#9a6ae0', 60); elBurst(st, 'shadow', o.x, o.y, 2); },
  crystal(st, o) { burst(st, o, '#f0d08a', 70); elBurst(st, 'earth', o.x, o.y); },
  freeze(st, o) { elBurst(st, 'ice', o.x, o.y, 2); burst(st, o, '#9fe7ff', 60); },
  steam(st, o) { for (let i = 0; i < 16; i++) P(st, { kind: 'steam', x: o.x + rnd(-50, 50), y: o.y - rnd(10, 80), vx: rnd(-20, 20), vy: -rnd(10, 40), life: rnd(1, 1.6), size: rnd(14, 24) }); },
  wildfire(st, o) { ring(st, o, '#ff9a3a', 130); for (let i = 0; i < 3; i++) st.fx.push({ type: 'fire', x: o.x + rnd(-60, 60), y: o.y + rnd(-20, 20), f: 1, s: 1, t: -i * 0.1, life: 1.6, seed: rnd(0, 9), pal: 'fire' }); },
};
function burst(st, o, col, r, col2) { st.fx.push({ type: 'burstel', x: o.x, y: o.y, f: 1, s: 1, t: 0, life: 0.45, r, col, col2, rot: rnd(0, 1) }); }
function ring(st, o, col, r) { st.fx.push({ type: 'ring', ground: true, x: o.x, y: o.y, f: 1, s: 1, t: 0, life: 0.6, r, col }); }

// 包住 fxAt：帶元素的特效加上元素粒子；處理反應與導電
const fxAt0 = SG.fxAt;
SG.fxAt = function (stage, o) {
  if (o.k === 'react') { const f = REACT_FX[o.r]; if (f) f(stage, o); return; }
  if (o.k === 'chainzap') return; // 導電的畫面在 react 裡畫
  if (o.k === 'recall') { stage.fx.push({ type: 'sigil', ground: true, x: o.x, y: o.y, f: 1, s: 1, t: 0, life: o.dur || 3, r: 70, col: '#ffe28a', ch: '歸', ult: 1, seed: 0, recallId: o.id }); return; }
  if (o.k === 'recallx') { stage.fx.forEach((e) => { if (e.recallId === o.id) e.t = Math.max(e.t, e.life * 0.7); }); return; }
  if (o.k === 'recalldone') {
    stage.fx.push({ type: 'pillar', x: o.x, y: o.y, f: 1, s: 1, t: 0, life: 0.8, col: '#ffe28a', w: 50 });
    elBurst(stage, 'holy', o.x, o.y, 1.5);
    return;
  }
  if (o.k === 'cast') {
    const e = EL[o.el], col = e ? e.col : (o.col || '#ffe28a');
    stage.fx.push({ type: 'sigil', ground: true, x: o.x, y: o.y, f: 1, s: 1, t: 0, life: o.ult ? 1.3 : 0.75, r: o.ult ? 95 : 58, col, ch: e ? e.name : '', ult: o.ult, seed: Math.random() * 6 });
    if (e) elBurst(stage, o.el, o.x, o.y, o.ult ? 1.5 : 0.6);
    if (o.ult && e) stage.fx.push({ type: 'pillar', x: o.x, y: o.y, f: 1, s: 1, t: 0, life: 0.7, col, w: 46 });
    return;
  }
  fxAt0(stage, o);
  if (o.el && o.k !== 'warn' && o.k !== 'puff') elBurst(stage, o.el, o.x, o.y, o.k === 'slam' || o.k === 'thunder' ? 2 : 1);
};

// 動作特效（揮砍、突刺等）跟著技能元素換色並噴粒子；view 在角色放技能時設定 actor.fxEl
const spawn0 = SG.spawn;
SG.spawn = function (stage, a, ev, P0) {
  if (!a.fxEl || !EL[a.fxEl] || ev.col) { spawn0(stage, a, ev, P0); return; }
  spawn0(stage, a, Object.assign({}, ev, { col: EL[a.fxEl].col }), P0);
  if (ev.fx === 'swoosh' || ev.fx === 'thrust' || ev.fx === 'impact' || ev.fx === 'slam') elBurst(stage, a.fxEl, a.x + a.f * 50 * a.s, a.y, 0.5);
};

// ---------- 單位身上的元素狀態 ----------
const MARK_PART = {
  fire: (st, u) => P(st, { kind: 'ember', x: u.x + rnd(-14, 14), y: u.y - rnd(20, 80), vy: -rnd(40, 90), life: rnd(0.4, 0.8), size: rnd(1.2, 2.6), col: '#ffb24a' }),
  ice: (st, u) => P(st, { kind: 'snow', x: u.x + rnd(-18, 18), y: u.y - rnd(40, 100), vy: rnd(15, 30), life: rnd(0.6, 1.1), size: rnd(1, 2) }),
  thunder: (st, u) => P(st, { kind: 'zap', x: u.x + rnd(-16, 16), y: u.y - rnd(20, 90), life: rnd(0.1, 0.25), size: rnd(3, 6) }),
  wind: (st, u) => P(st, { kind: 'leaf', x: u.x + rnd(-24, 24), y: u.y - rnd(20, 70), vx: rnd(-40, 40), vy: -rnd(10, 40), life: rnd(0.6, 1), size: rnd(2.5, 4), ph: rnd(0, 6) }),
  poison: (st, u) => P(st, { kind: 'bubble', x: u.x + rnd(-16, 16), y: u.y - rnd(10, 70), vy: -rnd(20, 40), life: rnd(0.5, 0.9), size: rnd(2, 3.5) }),
  shadow: (st, u) => P(st, { kind: 'wisp', x: u.x + rnd(-16, 16), y: u.y - rnd(20, 80), vy: -rnd(20, 40), life: rnd(0.6, 1), size: rnd(5, 9) }),
  holy: (st, u) => P(st, { kind: 'mote', x: u.x + rnd(-18, 18), y: u.y - rnd(10, 80), vy: -rnd(30, 60), life: rnd(0.6, 1), size: rnd(1.2, 2.2) }),
  earth: (st, u) => P(st, { kind: 'dust', x: u.x + rnd(-18, 18), y: u.y - rnd(0, 10), vx: rnd(-20, 20), vy: -rnd(5, 15), life: rnd(0.5, 0.8), size: rnd(4, 7) }),
};
SG.elUnit = function (stage, u, dt, world) {
  if (u.mk && MARK_PART[u.mk.el] && Math.random() < dt * 9) MARK_PART[u.mk.el](stage, u);
  if (u.st.burn > 0 && Math.random() < dt * 8) P(stage, { kind: u.st.burnFire ? 'ember' : 'bubble', x: u.x + rnd(-14, 14), y: u.y - rnd(20, 80), vy: -rnd(40, 90), life: rnd(0.4, 0.8), size: rnd(1.5, 3), col: '#ff9a3a' });
  // 涉水（江面、淺灘）：走動時留下漣漪
  if (SG.MAP.waterAt && SG.MAP.waterAt(u.x, u.y)) {
    u._rip = (u._rip || 0) - dt;
    const moving = u.anim === 'walk' || u.anim === 'run' || u.loop === 'walk' || u.loop === 'run';
    if (u._rip <= 0) { u._rip = moving ? 0.28 : 1.2; P(stage, { kind: 'ripple', x: u.x, y: u.y, life: 1, size: u.kind === 'hero' ? 12 : 8 }); }
  }
};
// 回城進度：武將頭上的金色圈
SG.drawRecall = function (ctx, u) {
  if (!u.recall) return;
  const s = (u.spec && u.spec.size) || 1, x = u.x, y = u.y - 150 * s, k = 1 - u.recall.t / u.recall.dur;
  ctx.save();
  ctx.fillStyle = 'rgba(12,14,20,.8)'; ctx.beginPath(); ctx.arc(x, y, 13, 0, TAU); ctx.fill();
  ctx.strokeStyle = '#ffe28a'; ctx.lineWidth = 3; ctx.beginPath(); ctx.arc(x, y, 13, -Math.PI / 2, -Math.PI / 2 + TAU * k); ctx.stroke();
  ctx.fillStyle = '#ffe28a'; ctx.font = '900 13px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText('歸', x, y + 0.5);
  ctx.restore();
};
// 血條上方的元素印記字
SG.drawMark = function (ctx, u, time) {
  if (!u.mk || !EL[u.mk.el]) return;
  const e = EL[u.mk.el], s = (u.spec && u.spec.size) || 1, x = u.x - 36, y = u.y - (u.kind === 'hero' ? 134 : 96) * s;
  const fade = u.mk.t < 1 ? 0.4 + 0.6 * Math.abs(Math.sin(time * 10)) : 1;
  ctx.save(); ctx.globalAlpha = fade;
  ctx.fillStyle = 'rgba(12,14,20,.85)'; ctx.beginPath(); ctx.arc(x, y, 9, 0, TAU); ctx.fill();
  ctx.strokeStyle = e.col; ctx.lineWidth = 2; ctx.beginPath(); ctx.arc(x, y, 9, -Math.PI / 2, -Math.PI / 2 + TAU * Math.min(1, u.mk.t / 4)); ctx.stroke();
  ctx.fillStyle = e.col; ctx.font = '900 11px "Noto Serif TC", serif'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle'; ctx.fillText(e.name, x, y + 0.5);
  ctx.restore();
};

// ---------- 元素區域 ----------
// 回傳 true 表示已經完整畫好（不要再畫預設的虛線圈）
SG.drawElZone = function (ctx, z, T, stage) {
  const life = Math.min(1, z.t / 0.4);
  if (z.storm) { // 火旋風：旋轉的火柱
    ctx.save(); ctx.translate(z.x, z.y);
    ctx.globalCompositeOperation = 'lighter';
    const g = ctx.createRadialGradient(0, 0, 0, 0, 0, z.r); g.addColorStop(0, 'rgba(255,150,50,.35)'); g.addColorStop(1, 'rgba(255,80,20,0)');
    ctx.globalAlpha = life; ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(0, 0, z.r, z.r * K * 0.62, 0, 0, TAU); ctx.fill();
    for (let i = 0; i < 9; i++) {
      const ang = T * 4 + i / 9 * TAU, rr = z.r * (0.25 + 0.6 * ((i % 3) / 2)), x = Math.cos(ang) * rr, y = Math.sin(ang) * rr * K * 0.62;
      ctx.save(); ctx.translate(x, y); ctx.scale(0.5 + (i % 3) * 0.12, 0.6 + 0.3 * Math.sin(T * 9 + i));
      SG.FX.fire(ctx, { pal: 'fire', seed: i, small: 0 }, 0.4, T); ctx.restore();
    }
    ctx.restore();
    if (stage && Math.random() < 0.6) P(stage, { kind: 'ember', x: z.x + rnd(-z.r, z.r) * 0.6, y: z.y - rnd(20, 140), vx: rnd(-80, 80), vy: -rnd(80, 180), life: rnd(0.4, 0.9), size: rnd(1.5, 3), col: '#ffb24a' });
    return true;
  }
  if (z.steam) return true; // 蒸氣只有粒子
  if (z.wild) { // 燎原：整片蘆葦起火
    ctx.save(); ctx.translate(z.x, z.y); ctx.globalCompositeOperation = 'lighter';
    for (let i = 0; i < 7; i++) {
      const x = Math.cos(i * 2.4) * z.r * 0.6, y = Math.sin(i * 2.4) * z.r * 0.6 * K * 0.62;
      ctx.save(); ctx.translate(x, y); ctx.scale(0.6, 0.5 + 0.2 * Math.sin(T * 7 + i)); ctx.globalAlpha = life;
      SG.FX.fire(ctx, { pal: 'fire', seed: i * 3, small: 0 }, 0.4, T); ctx.restore();
    }
    ctx.restore();
    if (stage && Math.random() < 0.5) P(stage, { kind: 'smoke', x: z.x + rnd(-z.r, z.r) * 0.5, y: z.y - rnd(60, 120), vy: -rnd(20, 40), life: rnd(1, 1.6), size: rnd(14, 22) });
    return true;
  }
  if (z.el && EL[z.el] && (z.dmg || z.slow || z.root)) {
    const e = EL[z.el];
    ctx.save(); ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = 0.18 * life;
    const g = ctx.createRadialGradient(z.x, z.y, 0, z.x, z.y, z.r); g.addColorStop(0, e.col); g.addColorStop(1, 'rgba(0,0,0,0)');
    ctx.fillStyle = g; ctx.beginPath(); ctx.ellipse(z.x, z.y, z.r, z.r * K, 0, 0, TAU); ctx.fill(); ctx.restore();
    if (stage && Math.random() < 0.35 && MARK_PART[z.el]) MARK_PART[z.el](stage, { x: z.x + rnd(-z.r, z.r) * 0.7, y: z.y + rnd(-z.r, z.r) * K * 0.5 + 60 });
  }
  return false;
};

// ---------- 投射物尾跡 ----------
SG.elProj = function (stage, p) {
  if (!p.el || !MARK_PART[p.el] || Math.random() > 0.7) return;
  MARK_PART[p.el](stage, { x: p.x, y: p.y + 30 });
};

// ---------- 動態光源：用 lighter 疊一層柔光 ----------
SG.drawGlow = function (ctx, view, inView) {
  const w = view.w, stage = view.WS, L = [];
  for (const z of w.zones) if ((z.fire || z.storm || z.wild || (z.el && z.dmg)) && inView(z.x, z.y, 200)) L.push([z.x, z.y - 20, (z.r || 80) * 1.9, z.el && EL[z.el] && !z.fire ? EL[z.el].glow : '255,140,50', z.storm || z.wild ? 0.4 : 0.22]);
  for (const p of w.projs) if (p.el && EL[p.el] && inView(p.x, p.y, 120)) L.push([p.x, p.y - 40, 90, EL[p.el].glow, 0.35]);
  for (const e of stage.fx) {
    if (e.t < 0) continue;
    const k = e.t / e.life;
    if (e.type === 'fire') L.push([e.x, e.y - 30, 140 * (e.small ? 0.6 : 1), '255,140,50', 0.32 * (1 - k)]);
    else if (e.type === 'thunder' && k < 0.4) L.push([e.x, e.y - 60, 260, '220,220,255', 0.6 * (1 - k / 0.4)]);
    else if (e.type === 'burstel') L.push([e.x, e.y - 40, (e.r || 70) * 3, hexToRgb(e.col), 0.5 * (1 - k)]);
    else if (e.type === 'pillar') L.push([e.x, e.y - 80, 220, '255,233,168', 0.5 * (1 - k)]);
    else if ((e.type === 'crescent' || e.type === 'bolt') && e.col) L.push([e.x, e.y - 45, 110, hexToRgb(e.col), 0.25 * (1 - k)]);
  }
  for (const u of w.units) if (u.alive && u.st && u.st.burn > 0 && inView(u.x, u.y, 100)) L.push([u.x, u.y - 50, 90, '255,140,50', 0.25]);
  if (!L.length) return;
  ctx.save(); ctx.globalCompositeOperation = 'lighter';
  for (const [x, y, r, rgb, a] of L.slice(0, 48)) {
    if (a <= 0.01) continue;
    ctx.globalAlpha = Math.min(1, a); ctx.drawImage(lightSprite(rgb), x - r, y - r, r * 2, r * 2);
  }
  ctx.restore();
};
// 每種顏色只畫一次的柔光貼圖，之後縮放貼上（比每幀建漸層便宜很多）
const sprites = {};
function lightSprite(rgb) {
  if (sprites[rgb]) return sprites[rgb];
  const c = document.createElement('canvas'); c.width = c.height = 64;
  const g2 = c.getContext('2d'), g = g2.createRadialGradient(32, 32, 0, 32, 32, 32);
  g.addColorStop(0, `rgba(${rgb},1)`); g.addColorStop(0.4, `rgba(${rgb},.45)`); g.addColorStop(1, `rgba(${rgb},0)`);
  g2.fillStyle = g; g2.fillRect(0, 0, 64, 64);
  return (sprites[rgb] = c);
}
const rgbCache = {};
function hexToRgb(h) {
  if (!h || h[0] !== '#') return '255,255,255';
  if (rgbCache[h]) return rgbCache[h];
  const n = parseInt(h.length === 4 ? h.slice(1).split('').map((c) => c + c).join('') : h.slice(1, 7), 16);
  return (rgbCache[h] = [(n >> 16) & 255, (n >> 8) & 255, n & 255].join(','));
}

// ---------- 環境氛圍 ----------
SG.ambient = function (view, dt, x0, y0, vw, vh) {
  const st = view.WS, M = SG.MAP, T = st.time;
  const amb = view._amb || (view._amb = { ff: 0, leaf: 0, mist: 0 });
  // 螢火蟲：樹林附近
  amb.ff -= dt;
  if (amb.ff <= 0) {
    amb.ff = 0.12;
    const trees = M.trees, n = st.parts.reduce((s, p) => s + (p.kind === 'firefly'), 0);
    if (n < 26) for (let tries = 0; tries < 6; tries++) {
      const t = trees[(Math.random() * trees.length) | 0];
      if (t.x > x0 && t.x < x0 + vw && t.y > y0 && t.y < y0 + vh) { P(st, { kind: 'firefly', x: t.x + rnd(-80, 80), y: t.y - rnd(20, 120), life: rnd(4, 8), ph: rnd(0, 9) }); break; }
    }
  }
  // 落葉
  amb.leaf -= dt;
  if (amb.leaf <= 0) {
    amb.leaf = 0.25;
    const t = M.trees[(Math.random() * M.trees.length) | 0];
    if (t.x > x0 && t.x < x0 + vw && t.y > y0 && t.y < y0 + vh) P(st, { kind: 'leaf', x: t.x + rnd(-40, 40), y: t.y - rnd(100, 170) * t.s, vx: rnd(-20, 30) + (view.w.wind.on > 0 ? -90 : 0), vy: rnd(20, 40), life: rnd(2.5, 4), size: rnd(2.5, 4), ph: rnd(0, 6), col: Math.random() < 0.4 ? '#c9a24e' : '#7fae6a' });
  }
  // 江霧：沿著江面在畫面內飄
  amb.mist -= dt;
  if (amb.mist <= 0) {
    amb.mist = 0.9;
    const x = x0 + Math.random() * vw, ry = (M.river.a[1] + (x - M.river.a[0]) * (M.river.b[1] - M.river.a[1]) / (M.river.b[0] - M.river.a[0]));
    if (ry > y0 - 80 && ry < y0 + vh + 80) P(st, { kind: 'mist', x, y: ry + rnd(-50, 50), vx: rnd(10, 25), vy: 0, life: rnd(4, 6), size: rnd(60, 110) });
  }
};
// 雲影：世界座標裡緩緩飄過的大片陰影
SG.drawClouds = function (ctx, view, x0, y0, vw, vh) {
  const T = view.WS.time, M = SG.MAP;
  ctx.save();
  for (let i = 0; i < 7; i++) {
    const span = M.W + 2400, cx = ((i * 1913 + T * 22) % span) - 1200, cy = (i * 1277) % M.H, rx = 520 + (i % 3) * 160, ry = rx * 0.55;
    if (cx + rx < x0 || cx - rx > x0 + vw || cy + ry < y0 || cy - ry > y0 + vh) continue;
    const g = ctx.createRadialGradient(cx, cy, 0, cx, cy, rx);
    g.addColorStop(0, 'rgba(10,16,24,.16)'); g.addColorStop(0.7, 'rgba(10,16,24,.08)'); g.addColorStop(1, 'rgba(10,16,24,0)');
    ctx.fillStyle = g; ctx.save(); ctx.translate(cx, cy); ctx.scale(1, ry / rx); ctx.translate(-cx, -cy);
    ctx.beginPath(); ctx.arc(cx, cy, rx, 0, TAU); ctx.fill(); ctx.restore();
  }
  ctx.restore();
};
